import React from 'react';

export default function HostOnPreviewBadge() {
  const disabled = (process.env.REACT_APP_HOST_ON_PREVIEW_BADGE || '').toLowerCase() === 'false';
  if (disabled) return null;

  return (
    <div
      role="status"
      aria-label="Host-On Development Preview"
      style={{
        position: 'fixed',
        bottom: '12px',
        right: '12px',
        zIndex: 9999,
        pointerEvents: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        borderRadius: '9999px',
        border: '1px solid #e2e8f0',
        background: 'rgba(255,255,255,0.95)',
        padding: '6px 12px',
        boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
        backdropFilter: 'blur(4px)',
      }}
    >
      <img
        src="https://www.host-on.de/favicon.ico"
        alt=""
        style={{ height: '16px', width: '16px', flexShrink: 0 }}
      />
      <span style={{ fontSize: '12px', fontWeight: 500, color: '#334155', whiteSpace: 'nowrap' }}>
        Host-On Development Preview
      </span>
    </div>
  );
}
